// extracted by mini-css-extract-plugin
module.exports = {"input":"_2RpTM___RadioInput-module__input","label":"_1RtTx___RadioInput-module__label"};